import axios, { AxiosRequestConfig } from "axios";
import Cookies from "js-cookie";
import { API_URL } from "lib/constants";
import { AppError } from "webrtc-player/common/app_error";
import { errorHandler } from "./utils";
const activeRequests = new Map<string, AbortController>();
export const axiosInstance = axios.create({
  baseURL: API_URL,
});

//  status>1000 will be a logic error,handle it as 200
axiosInstance.interceptors.response.use(
  (response) => {
    activeRequests.delete(
      //@ts-ignore
      response.config?.duplicationKey,
    );
    return response;
  },
  (error) => {
    if (error.code === "ERR_CANCELED") {
      return { code: "ERR_CANCELED" };
    }
    activeRequests.delete(error?.response.config?.duplicationKey);
    const appError = new AppError({
      name: error.response?.data?.name,
      code: error.response?.data?.code,
      message: error.response?.data?.message,
      status: error.response?.status,
    });
    const handledError = errorHandler(appError);
    if (handledError?.external && error.response?.data)
      error.response.data.external = handledError?.external;
    //替换默认异常抛出
    return error.response;
  },
);
export function sendHttpRequest(
  config: AxiosRequestConfig<any> & { duplicationKey?: string },
  paramToken?: string,
) {
  const abortController = new AbortController();
  if (config?.duplicationKey) {
    const key = config.duplicationKey;
    if (activeRequests.has(key)) {
      activeRequests.get(key)!.abort();
      activeRequests.delete(key);
    }

    activeRequests.set(key, abortController);
  }

  const token = paramToken || Cookies.get("token");
  let orgId = Cookies.get("orgId");
  if (orgId === "undefined") orgId = null;

  const xhrPromise = axiosInstance(
    Object.assign(config, {
      signal: abortController.signal,
      headers: {
        Authorization: `Bearer ${token}`,
        "x-agent": "web",
        "x-org-id": orgId || undefined,
        ...config.headers,
      },
    }),
  );
  //@ts-ignore
  xhrPromise.abort = () => {
    abortController.abort();
  };
  return xhrPromise;
}

export function sendGetHttpRequest(url, orgId?) {
  return sendHttpRequest({
    method: "get",
    url: url,
    headers: {
      "Content-Type": "application/json",
      "x-org-id": orgId ?? Cookies.get("orgId"),
    },
  });
}

export function sendPostHttpRequest(url, data, orgId?) {
  return sendHttpRequest({
    method: "post",
    url: url,
    data: data,
    headers: {
      "Content-Type": "application/json",
      "x-org-id": orgId ?? Cookies.get("orgId"),
    },
  });
}

export function fetchWithParams(url: string, token: string, orgId?: string) {
  let cookieOrgId = Cookies.get("orgId");
  if (cookieOrgId === "undefined") cookieOrgId = null;
  return axiosInstance
    .get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-org-id": orgId ?? cookieOrgId,
      },
    })
    .then((res) => res.data);
}

export function fetchPostWithParams(
  url: string,
  token: string,
  orgId?: string,
  postData?: any,
) {
  return axiosInstance
    .post(url, postData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-org-id": orgId,
      },
    })
    .then((res) => res.data);
}
